import React from 'react';
// Import Local Components
import CompanyTransactionLimits from './components/CompanyTransactionLimits';
import CompanyVelocityLimits from './components/CompanyVelocityLimits';

export default function({
  subtab,
  transactionLimits,
  transactionColumns,
  velocityLimits,
  velocityColumns,
}) {
  return <>
    {subtab === 'transaction' ? (
      <CompanyTransactionLimits
        limits={transactionLimits}
        columns={transactionColumns}
      />
    ) : (
      <CompanyVelocityLimits
        limits={velocityLimits}
        columns={velocityColumns}
      />
    )}
  </>;
};
